<template>
  <BusinessCrud
    title="产品文件"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getProductFileList"
    :save-api="saveProductFile"
    :delete-api="deleteProductFile"
    :defaults="{ isVisible: 1, sortOrder: 0, fileType: 'PDF', fileUrl: 'file/fff.png' }"
  >
    <template slot="preview" slot-scope="{ record }">
      <div class="file-thumbnail" @click="openFile(record)">
        <img v-if="isImageFile(record)" :src="normalizeFileUrl(record.fileUrl)" :alt="record.fileName">
        <iframe v-else-if="isPdfFile(record)" :src="normalizeFileUrl(record.fileUrl)" :title="record.fileName"></iframe>
        <a-icon v-else type="file" />
      </div>
    </template>
  </BusinessCrud>
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { API_BASE_URL, getProductFileList, saveProductFile, deleteProductFile } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    return {
      getProductFileList,
      saveProductFile,
      deleteProductFile,
      searchFields: [
        { key: 'productName', label: '产品名称' },
        { key: 'fileName', label: '文件名称' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '缩略图', dataIndex: 'fileUrl', width: 110, scopedSlots: { customRender: 'preview' } },
        { title: '产品名称', dataIndex: 'productName' },
        { title: '文件名称', dataIndex: 'fileName' },
        { title: '类型', dataIndex: 'fileType' },
        { title: '文件地址', dataIndex: 'fileUrl' },
        { title: '展示', dataIndex: 'isVisible', scopedSlots: { customRender: 'status' } },
        { title: '排序', dataIndex: 'sortOrder' }
      ],
      formFields: [
        { key: 'productId', label: '产品ID', type: 'number', min: 0 },
        { key: 'productName', label: '产品名称' },
        { key: 'fileName', label: '文件名称' },
        { key: 'fileType', label: '文件类型' },
        { key: 'fileUrl', label: '文件地址' },
        { key: 'sortOrder', label: '排序', type: 'number', min: 0 },
        { key: 'isVisible', label: '前台展示', type: 'switch' }
      ]
    }
  },
  methods: {
    normalizeFileUrl(url) {
      const value = String(url || '').trim()
      const uploadIndex = value.indexOf('/uploads/')
      if (uploadIndex >= 0) return API_BASE_URL.replace(/\/$/, '') + value.slice(uploadIndex).split(/[?#]/)[0]
      if (value.indexOf('uploads/') === 0) return API_BASE_URL.replace(/\/$/, '') + '/' + value
      if (/^https?:\/\//i.test(value)) return value
      if (value === 'file/fff.png') return '/fff.png'
      return value.charAt(0) === '/' ? value : '/' + value
    },
    isImageFile(file) {
      return /^(IMAGE|JPG|JPEG|PNG|GIF|WEBP|BMP)$/i.test(file.fileType || '') || /\.(jpg|jpeg|png|gif|webp|bmp)(\?.*)?$/i.test(file.fileUrl || '')
    },
    isPdfFile(file) {
      return /^PDF$/i.test(file.fileType || '') || /\.pdf(\?.*)?$/i.test(file.fileUrl || '')
    },
    openFile(file) {
      const url = this.normalizeFileUrl(file && file.fileUrl)
      if (url) window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.file-thumbnail { width: 82px; height: 62px; overflow: hidden; display: flex; align-items: center; justify-content: center; border: 1px solid #e5e7eb; border-radius: 4px; background: #fff; color: #1684ff; cursor: pointer; }
.file-thumbnail img, .file-thumbnail iframe { width: 100%; height: 100%; border: 0; object-fit: contain; pointer-events: none; }
.file-thumbnail .anticon { font-size: 30px; }
</style>
